import { jsxs as m, jsx as o } from "react/jsx-runtime";
import { E as e, S as f } from "./icons.types-0722eef5.js";
function Z({ title: s, titleId: n, size: a, width: i, height: r, extended: l = !1, ...t }) {
  const c = l ? e : f, v = a ? c[a] : i || c[l ? "s" : "l"], h = a ? c[a] : r || c[l ? "s" : "l"];
  return /* @__PURE__ */ m(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 32",
      width: v,
      height: h,
      "aria-labelledby": n,
      ...t,
      children: [
        s ? /* @__PURE__ */ o("title", { id: n, children: s }) : null,
        /* @__PURE__ */ o(
          "path",
          {
            fill: "currentColor",
            d: "M7.667 22.82v-8c0-.283.096-.52.287-.712a.969.969 0 0 1 .713-.288c.284 0 .521.096.713.288.191.192.287.43.287.712v8c0 .284-.096.521-.288.713a.968.968 0 0 1-.713.288.967.967 0 0 1-.712-.288.968.968 0 0 1-.287-.712Zm7.333 0v-8c0-.283.096-.52.288-.712A.969.969 0 0 1 16 13.82c.284 0 .521.096.713.288.191.192.287.43.287.712v8c0 .284-.096.521-.288.713a.969.969 0 0 1-.712.288.967.967 0 0 1-.713-.288.968.968 0 0 1-.287-.712ZM4.692 28.488a.968.968 0 0 1-.712-.287.968.968 0 0 1-.288-.713c0-.284.096-.521.288-.713a.968.968 0 0 1 .712-.287h22.616c.283 0 .52.096.712.288.192.192.288.43.288.713s-.096.52-.288.712a.968.968 0 0 1-.712.287H4.692Zm17.641-5.666v-8c0-.284.096-.521.288-.713a.969.969 0 0 1 .713-.288c.283 0 .52.096.712.288.192.192.287.43.287.712v8c0 .284-.096.521-.287.713a.968.968 0 0 1-.713.288.967.967 0 0 1-.712-.288.968.968 0 0 1-.288-.712Zm5.026-11.667H4.546a.824.824 0 0 1-.605-.249.82.82 0 0 1-.249-.603V9.78a.77.77 0 0 1 .13-.449.995.995 0 0 1 .345-.306L14.94 3.754c.333-.16.685-.241 1.057-.241.372 0 .726.08 1.061.24l10.72 5.24a.947.947 0 0 1 .528.855v.36c0 .274-.089.5-.267.678a.922.922 0 0 1-.681.268Zm-18.938-2H23.58l-7.4-3.59a.452.452 0 0 0-.18-.038c-.06 0-.12.013-.18.038l-7.4 3.59Z"
          }
        )
      ]
    }
  );
}
export {
  Z as Bank
};
